export { default } from '../../RatePage';
